import { DEFAULT_MAX_SHOW_OF_MEETINGS } from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Management/Details/components/Meetings/utils/constants';

/**
 * 获取默认展示的会议记录的数量
 * @param maxShow 默认展示的会议记录的最大数量
 * @returns 默认展示的会议记录的最大数量（安全的数字）
 */
export const getSecureMaxShowOfMeetingsPanels = (maxShow?: number): number => {
  if (typeof maxShow === 'number' && !Number.isNaN(maxShow)) return maxShow;
  return DEFAULT_MAX_SHOW_OF_MEETINGS;
};

/**
 * 过滤无效会议数据，面板header组件 需要展示，会议名称、会议决议时间、会议创建信息（创建时间、创建人）
 * 只保留 会议id、Event Type、MeetingTime（会议决议时间） 都不会空的会议
 * @param meetins 会议列表数据
 */
export const getValidMeetings = (meetins?: IStudioManagementMeeting[]): IStudioManagementMeeting[] => {
  if (!Array.isArray(meetins)) return [];
  return meetins.filter((meeting) => {
    const { id, eventName, meetingTime } = meeting || {};
    // 会议id不为空
    const flag1 = id !== undefined && id !== null;
    // 会议名称不为空
    const flag2 = eventName?.trim();
    // 会议决议时间不为空
    const flag3 = meetingTime?.trim();
    return flag1 && flag2 && flag3;
  });
};

export const getAttachmentKey = (
  meeting: IStudioManagementMeeting,
  attachment: IStudioManagementMeetingFileTag,
): string => {
  const { id } = meeting || {};
  const { filePath } = attachment || {};
  return `${id}-${filePath}`;
};

/**
 * 获取会议附件下载loading集合初始值
 * @param meetings meetins 会议列表数据
 * @returns 会议附件下载loading集合初始值，初始都为false
 */
export const getInitialMeetingsAttachmentDownloadings = (
  meetings?: IStudioManagementMeeting[],
): {
  [key: string]: boolean;
} => {
  const downloadings: {
    [key: string]: boolean;
  } = {};
  if (!Array.isArray(meetings)) return downloadings;
  for (const meeting of meetings) {
    const { fileTagList } = meeting || {};
    if (!Array.isArray(fileTagList)) continue;
    for (const fileTag of fileTagList) {
      const attachmentKey = getAttachmentKey(meeting, fileTag);
      downloadings[attachmentKey] = false;
    }
  }
  return downloadings;
};
